/**
 * Stellt die Geraetekennwerte bereit, von denen jede Messung abhaengt.
 *
 * Die Erkennung laeuft genau einmal beim Start. Bis sie durch ist, wird nichts
 * gezeichnet - eine Bahn mit falschem Massstab zu zeigen waere schlimmer als
 * einen Moment zu warten.
 */

import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react'
import { detectDeviceMetrics, type DeviceMetrics } from './engine/dpi'

interface DeviceContextValue {
  metrics: DeviceMetrics
  /** Nach einer Kalibrierung erneut erkennen. */
  refresh: () => Promise<void>
}

const DeviceContext = createContext<DeviceContextValue | null>(null)

export function DeviceProvider({ children }: { children: ReactNode }) {
  const [metrics, setMetrics] = useState<DeviceMetrics | null>(null)

  const refresh = useCallback(async () => {
    setMetrics(await detectDeviceMetrics())
  }, [])

  useEffect(() => {
    void refresh()
  }, [refresh])

  if (!metrics) {
    return (
      <div className="boot">
        <div className="boot__pulse" />
        <p>Bahn wird vermessen…</p>
      </div>
    )
  }

  return <DeviceContext.Provider value={{ metrics, refresh }}>{children}</DeviceContext.Provider>
}

export function useDevice(): DeviceContextValue {
  const value = useContext(DeviceContext)
  if (!value) throw new Error('useDevice ausserhalb von DeviceProvider verwendet')
  return value
}
